import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import shareImg from '../images/shareIcon.svg';

function DoneDrinkCard(props) {
  const { recipe, index } = props;
  const { id, name, image, doneDate, alcoholicOrNot, category } = recipe;
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    navigator.clipboard.writeText(`http://localhost:3000/drinks/${id}`);
    setCopied(true);
  };

  return (
    <div className="d-card">
      <Link to={ `/drinks/${id}` }>
        <img
          className="d-img"
          data-testid={ `${index}-horizontal-image` }
          alt={ name }
          src={ image }
        />
      </Link>
      <div className="d-card-details">
        <Link to={ `/drinks/${id}` }>
          <h1 data-testid={ `${index}-horizontal-name` } className="d-title">
            {name}
          </h1>
        </Link>
        <h3 data-testid={ `${index}-horizontal-top-text` } className="d-infos">
          { `${category} - ${alcoholicOrNot ? 'Alcoholic' : 'Not alcoholic'}` }
        </h3>
        <p data-testid={ `${index}-horizontal-done-date` }>{doneDate}</p>
        <button
          type="button"
          className="d-share-btn"
          data-testid={ `${index}-horizontal-share-btn` }
          src={ shareImg }
          onClick={ handleClick }
        >
          <img src={ shareImg } alt="share" />
        </button>
        {
          copied && <p>Link copied!</p>
        }
      </div>
    </div>
  );
}

DoneDrinkCard.propTypes = {
  recipe: PropTypes.object,
  index: PropTypes.string,
}.isRequired;

export default DoneDrinkCard;
